import React, { useState, useEffect, useCallback } from 'react';
import './PhotographProfile.css';
import DashboardSidebar from './DashboardSidebar';
import Multiselect from 'multiselect-react-dropdown';
import { HelpCircle, ChevronDown, FileText, Settings, X, Camera, UserCircle, MapPin, Star, Edit3, RotateCcw, Plus, Trash2, Award, Hash, AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase';
import { onAuthStateChanged, signOut, updateProfile } from 'firebase/auth';
import { doc, getDoc, updateDoc, deleteField } from 'firebase/firestore'; // Added deleteField import

// Local Storage Helper - FIXED THE TYPO
const LocalStorageHelper = {
  saveLoginData: (userId, email, name, userType = 'user') => {
    localStorage.setItem('isLoggedIn', 'true');
    localStorage.setItem('userId', userId);
    localStorage.setItem('userEmail', email);
    localStorage.setItem('userName', name);
    localStorage.setItem('userType', userType);
  },

  isLoggedIn: () => {
    return localStorage.getItem('isLoggedIn') === 'true';
  },

  getLoginData: () => {
    return {
      userId: localStorage.getItem('userId'),
      email: localStorage.getItem('userEmail'),
      name: localStorage.getItem('userName'),
      userType: localStorage.getItem('userType'),
    };
  },

  clearLoginData: () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('userId');
    localStorage.removeItem('userEmail'); // FIXED: was removeRemove
    localStorage.removeItem('userName');
    localStorage.removeItem('userType');
  }
};

const PhotographProfile = () => {
  const navigate = useNavigate();
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [originalProfileData, setOriginalProfileData] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  
  // Profile completion states
  const [profileCompletion, setProfileCompletion] = useState(0);
  const [showProfileIncompleteModal, setShowProfileIncompleteModal] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  
  // Updated: Added professional details to profileData state - FIXED language default
  const [profileData, setProfileData] = useState({
    name: '',
    email: '',
    phone: '',
    location: '',
    profileImage: '',
    dateOfBirth: '',
    state: '',
    city: '',
    address: '',
    language: '', // CHANGED: No longer defaults to 'English'
    description: '',
    serviceAreas: [],
    serviceCategories: {},
    hasStudio: false,
    studioName: '',
    studioAddress: '',
    studioPhone: '',
    gstNumber: '',
    // Policies section
    policies: {
      cancellationPolicy: '',
      paymentTerms: '',
      travelCostBearer: '',
      deliveryTime: ''
    },
    // Professional Details section
    professionalDetails: {
      workLocation: '',
      proficientPosing: false,
      completedProjects: 0
    }
  });
  
  const [avatarUrl, setAvatarUrl] = useState('');

  // Authentication state
  const [photographerData, setPhotographerData] = useState(null);
  const [photographerName, setPhotographerName] = useState('Photographer');
  const [profilePhoto, setProfilePhoto] = useState(null);

  // Service Areas and Categories formatted for multiselect
  const [allServiceAreas] = useState([
    { name: "Mumbai", id: "mumbai", category: "metro" },
    { name: "Delhi", id: "delhi", category: "metro" },
    { name: "Bangalore", id: "bangalore", category: "metro" },
    { name: "Hyderabad", id: "hyderabad", category: "metro" },
    { name: "Ahmedabad", id: "ahmedabad", category: "metro" },
    { name: "Chennai", id: "chennai", category: "metro" },
    { name: "Kolkata", id: "kolkata", category: "metro" },
    { name: "Surat", id: "surat", category: "tier1" },
    { name: "Pune", id: "pune", category: "metro" },
    { name: "Jaipur", id: "jaipur", category: "tier1" },
    { name: "Lucknow", id: "lucknow", category: "tier1" },
    { name: "Kanpur", id: "kanpur", category: "tier1" },
    { name: "Nagpur", id: "nagpur", category: "tier1" },
    { name: "Indore", id: "indore", category: "tier1" },
    { name: "Thane", id: "thane", category: "tier1" },
    { name: "Bhopal", id: "bhopal", category: "tier1" },
    { name: "Visakhapatnam", id: "visakhapatnam", category: "tier2" },
    { name: "Pimpri-Chinchwad", id: "pimpri_chinchwad", category: "tier2" },
    { name: "Patna", id: "patna", category: "tier2" },
    { name: "Vadodara", id: "vadodara", category: "tier2" },
    { name: "Ghaziabad", id: "ghaziabad", category: "tier2" },
    { name: "Ludhiana", id: "ludhiana", category: "tier2" },
    { name: "Agra", id: "agra", category: "tier2" },
    { name: "Nashik", id: "nashik", category: "tier2" },
    { name: "Faridabad", id: "faridabad", category: "tier2" },
    { name: "Meerut", id: "meerut", category: "tier2" },
    { name: "Rajkot", id: "rajkot", category: "tier2" },
    { name: "Kalyan-Dombivali", id: "kalyan_dombivali", category: "tier2" },
    { name: "Vasai-Virar", id: "vasai_virar", category: "tier2" },
    { name: "Varanasi", id: "varanasi", category: "tier2" },
    { name: "Srinagar", id: "srinagar", category: "tier2" },
    { name: "Aurangabad", id: "aurangabad", category: "tier2" },
    { name: "Dhanbad", id: "dhanbad", category: "tier2" },
    { name: "Amritsar", id: "amritsar", category: "tier2" },
    { name: "Navi Mumbai", id: "navi_mumbai", category: "tier2" },
    { name: "Allahabad", id: "allahabad", category: "tier2" },
    { name: "Ranchi", id: "ranchi", category: "tier2" },
    { name: "Howrah", id: "howrah", category: "tier2" },
    { name: "Coimbatore", id: "coimbatore", category: "tier2" },
    { name: "Jabalpur", id: "jabalpur", category: "tier2" },
    { name: "Gwalior", id: "gwalior", category: "tier2" },
    { name: "Vijayawada", id: "vijayawada", category: "tier2" },
    { name: "Jodhpur", id: "jodhpur", category: "tier2" },
    { name: "Madurai", id: "madurai", category: "tier2" },
    { name: "Raipur", id: "raipur", category: "tier2" },
    { name: "Kota", id: "kota", category: "tier2" },
    { name: "Guwahati", id: "guwahati", category: "tier2" },
    { name: "Chandigarh", id: "chandigarh", category: "tier2" },
    { name: "Solapur", id: "solapur", category: "tier2" },
    { name: "Hubli-Dharwad", id: "hubli_dharwad", category: "tier2" },
    { name: "Bareilly", id: "bareilly", category: "tier3" },
    { name: "Moradabad", id: "moradabad", category: "tier3" },
    { name: "Mysore", id: "mysore", category: "tier3" },
    { name: "Gurgaon", id: "gurgaon", category: "tier3" },
    { name: "Aligarh", id: "aligarh", category: "tier3" },
    { name: "Jalandhar", id: "jalandhar", category: "tier3" },
    { name: "Tiruchirappalli", id: "tiruchirappalli", category: "tier3" },
    { name: "Bhubaneswar", id: "bhubaneswar", category: "tier3" },
    { name: "Salem", id: "salem", category: "tier3" },
    { name: "Mira-Bhayandar", id: "mira_bhayandar", category: "tier3" },
    { name: "Warangal", id: "warangal", category: "tier3" },
    { name: "Thiruvananthapuram", id: "thiruvananthapuram", category: "tier3" },
    { name: "Guntur", id: "guntur", category: "tier3" },
    { name: "Bhiwandi", id: "bhiwandi", category: "tier3" },
    { name: "Saharanpur", id: "saharanpur", category: "tier3" },
    { name: "Gorakhpur", id: "gorakhpur", category: "tier3" },
    { name: "Bikaner", id: "bikaner", category: "tier3" },
    { name: "Amravati", id: "amravati", category: "tier3" },
    { name: "Noida", id: "noida", category: "tier3" },
    { name: "Jamshedpur", id: "jamshedpur", category: "tier3" },
    { name: "Bhilai", id: "bhilai", category: "tier3" },
    { name: "Cuttack", id: "cuttack", category: "tier3" },
    { name: "Firozabad", id: "firozabad", category: "tier3" },
    { name: "Kochi", id: "kochi", category: "tier3" },
    { name: "Nellore", id: "nellore", category: "tier3" },
    { name: "Bhavnagar", id: "bhavnagar", category: "tier3" },
    { name: "Dehradun", id: "dehradun", category: "tier3" },
    { name: "Durgapur", id: "durgapur", category: "tier3" },
    { name: "Asansol", id: "asansol", category: "tier3" },
    { name: "Rourkela", id: "rourkela", category: "tier3" },
    { name: "Nanded", id: "nanded", category: "tier3" },
    { name: "Kolhapur", id: "kolhapur", category: "tier3" },
    { name: "Ajmer", id: "ajmer", category: "tier3" },
    { name: "Akola", id: "akola", category: "tier3" },
    { name: "Gulbarga", id: "gulbarga", category: "tier3" },
    { name: "Jamnagar", id: "jamnagar", category: "tier3" },
    { name: "Ujjain", id: "ujjain", category: "tier3" },
    { name: "Loni", id: "loni", category: "tier3" },
    { name: "Siliguri", id: "siliguri", category: "tier3" },
    { name: "Jhansi", id: "jhansi", category: "tier3" },
    { name: "Ulhasnagar", id: "ulhasnagar", category: "tier3" },
    { name: "Jammu", id: "jammu", category: "tier3" },
    { name: "Sangli-Miraj & Kupwad", id: "sangli_miraj_kupwad", category: "tier3" },
    { name: "Mangalore", id: "mangalore", category: "tier3" },
    { name: "Erode", id: "erode", category: "tier3" },
    { name: "Belgaum", id: "belgaum", category: "tier3" },
    { name: "Ambattur", id: "ambattur", category: "tier3" },
    { name: "Tirunelveli", id: "tirunelveli", category: "tier3" },
    { name: "Malegaon", id: "malegaon", category: "tier3" },
    { name: "Gaya", id: "gaya", category: "tier3" },
    { name: "Jalgaon", id: "jalgaon", category: "tier3" },
    { name: "Udaipur", id: "udaipur", category: "tier3" },
    { name: "Maheshtala", id: "maheshtala", category: "tier3" },
    { name: "Davanagere", id: "davanagere", category: "tier3" },
    { name: "Kozhikode", id: "kozhikode", category: "tier3" }
  ]);

  const [allServiceCategories] = useState([
    { name: 'Wedding Photography', id: 'wedding', category: 'events' },
    { name: 'Portrait Photography', id: 'portrait', category: 'personal' },
    { name: 'Event Photography', id: 'event', category: 'events' },
    { name: 'Fashion Photography', id: 'fashion', category: 'commercial' },
    { name: 'Product Photography', id: 'product', category: 'commercial' },
    { name: 'Corporate Photography', id: 'corporate', category: 'commercial' },
    { name: 'Nature Photography', id: 'nature', category: 'artistic' },
    { name: 'Food Photography', id: 'food', category: 'commercial' },
    { name: 'Real Estate Photography', id: 'real_estate', category: 'commercial' },
    { name: 'Maternity Photography', id: 'maternity', category: 'personal' },
    { name: 'Newborn Photography', id: 'newborn', category: 'personal' },
    { name: 'Family Photography', id: 'family', category: 'personal' },
    { name: 'Engagement Photography', id: 'engagement', category: 'events' },
    { name: 'Commercial Photography', id: 'commercial', category: 'commercial' },
    { name: 'Sports Photography', id: 'sports', category: 'events' },
    { name: 'Travel Photography', id: 'travel', category: 'artistic' },
    { name: 'Street Photography', id: 'street', category: 'artistic' },
    { name: 'Architecture Photography', id: 'architecture', category: 'artistic' },
    { name: 'Lifestyle Photography', id: 'lifestyle', category: 'personal' },
    { name: 'Documentary Photography', id: 'documentary', category: 'artistic' },
    { name: 'Baby Photography', id: 'baby', category: 'personal' },
    { name: 'Pet Photography', id: 'pet', category: 'personal' },
    { name: 'Headshot Photography', id: 'headshot', category: 'commercial' },
    { name: 'Boudoir Photography', id: 'boudoir', category: 'personal' },
    { name: 'Fine Art Photography', id: 'fine_art', category: 'artistic' },
    { name: 'Landscape Photography', id: 'landscape', category: 'artistic' },
    { name: 'Macro Photography', id: 'macro', category: 'artistic' },
    { name: 'Aerial Photography', id: 'aerial', category: 'commercial' },
    { name: 'Underwater Photography', id: 'underwater', category: 'artistic' },
    { name: 'Concert Photography', id: 'concert', category: 'events' }
  ]);

  // Service Categories pricing state
  const [selectedCategory, setSelectedCategory] = useState('');
  const [categoryPrice, setCategoryPrice] = useState('');

  // UPDATED: Calculate profile completion percentage - FIXED Language field validation
  const calculateProfileCompletion = useCallback(() => {
    const requiredFieldsToCheck = [
      // Basic info - ALL NOW REQUIRED
      { field: profileData.name, label: 'Full Name', icon: '👤', key: 'name' },
      { field: profileData.phone, label: 'Phone Number', icon: '📞', key: 'phone' },
      { field: profileData.location, label: 'Location', icon: '📍', key: 'location' },
      { field: profileData.description, label: 'Professional Description', icon: '📝', key: 'description' },
      { field: profileData.profileImage, label: 'Profile Picture', icon: '🖼️', key: 'profileImage' },
      
      // FIXED: Language field - now properly validates (empty string means incomplete)
      { field: profileData.language, label: 'Language', icon: '🌐', key: 'language' },
      
      { field: profileData.dateOfBirth, label: 'Date of Birth', icon: '📅', key: 'dateOfBirth' },
      { field: profileData.state, label: 'State', icon: '🏛️', key: 'state' },
      { field: profileData.city, label: 'City', icon: '🏙️', key: 'city' },
      { field: profileData.address, label: 'Address', icon: '🏠', key: 'address' },
      
      // Service areas (special check for array)
      { field: profileData.serviceAreas && profileData.serviceAreas.length > 0 ? 'filled' : '', label: 'Service Areas', icon: '🗺️', key: 'serviceAreas' },
      
      // Service categories (special check for object)
      { field: profileData.serviceCategories && Object.keys(profileData.serviceCategories).length > 0 && Object.values(profileData.serviceCategories).some(price => price > 0) ? 'filled' : '', label: 'Photography Services & Pricing', icon: '📸', key: 'serviceCategories' },
      
      // Policies - ALL 3 now required
      { field: profileData.policies?.cancellationPolicy, label: 'Cancellation Policy', icon: '📋', key: 'cancellationPolicy' },
      { field: profileData.policies?.paymentTerms, label: 'Payment Terms', icon: '💳', key: 'paymentTerms' },
      { field: profileData.policies?.travelCostBearer, label: 'Travel Cost Bearer', icon: '🚗', key: 'travelCostBearer' },
      
      // Professional details
      { field: profileData.professionalDetails?.workLocation, label: 'Work Location', icon: '🏆', key: 'workLocation' }
    ];

    let completedFields = 0;
    let missingFieldsList = [];
    const totalFields = requiredFieldsToCheck.length;

    requiredFieldsToCheck.forEach(({ field, label, icon, key }) => {
      const isFieldFilled = field && field.toString().trim() !== '';
      
      if (isFieldFilled) {
        completedFields++;
      } else {
        missingFieldsList.push({ field: key, label, icon });
      }
    });

    const completionPercentage = Math.round((completedFields / totalFields) * 100);
    
    setMissingFields(missingFieldsList);
    setProfileCompletion(completionPercentage);
    
    console.log('Profile completion calculated:', completionPercentage, '%');
    console.log('Missing fields:', missingFieldsList.map(f => f.label).join(', '));
    
    return completionPercentage;
  }, [profileData]);

  // Check if profile is complete and show modal if needed
  const checkAndShowProfileIncompleteModal = useCallback(() => {
    const completion = calculateProfileCompletion();
    
    if (completion < 100) {
      setShowProfileIncompleteModal(true);
    }
    
    return completion === 100;
  }, [calculateProfileCompletion]);

  // Generate avatar URL helper
  const generateAvatarUrl = (userData, user) => {
    const avatarSources = [
      userData?.profileImage,
      userData?.avatarUrl,
      userData?.avatar,
      user?.photoURL
    ];
    
    const validAvatar = avatarSources.find(url => url && url.trim() !== '' && url !== 'undefined');
    
    if (validAvatar) {
      return validAvatar;
    }
    
    const name = userData?.name || user?.displayName || "User";
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=6366f1&color=fff&size=128&bold=true&font-size=0.6`;
  };

  // Convert service areas from names to objects for multiselect
  const getSelectedServiceAreasObjects = () => {
    return allServiceAreas.filter(area => 
      profileData.serviceAreas.includes(area.name)
    );
  };

  // Service Areas handlers for multiselect
  const onServiceAreasSelect = (selectedList, selectedItem) => {
    const selectedNames = selectedList.map(item => item.name);
    setProfileData(prev => ({
      ...prev,
      serviceAreas: selectedNames
    }));
  };

  const onServiceAreasRemove = (selectedList, removedItem) => {
    const selectedNames = selectedList.map(item => item.name);
    setProfileData(prev => ({
      ...prev,
      serviceAreas: selectedNames
    }));
  };

  // Service Categories handlers
  const addServiceCategory = () => {
    if (selectedCategory && categoryPrice && !profileData.serviceCategories[selectedCategory]) {
      const price = parseFloat(categoryPrice);
      if (price > 0) {
        setProfileData(prev => ({
          ...prev,
          serviceCategories: {
            ...prev.serviceCategories,
            [selectedCategory]: price
          }
        }));
        setSelectedCategory('');
        setCategoryPrice('');
      }
    }
  };

  const removeServiceCategory = (category) => {
    setProfileData(prev => {
      const newCategories = { ...prev.serviceCategories };
      delete newCategories[category];
      return { ...prev, serviceCategories: newCategories };
    });
  };

  // Policy change handler
  const handlePolicyChange = (policyType, value) => {
    setProfileData(prev => ({
      ...prev,
      policies: {
        ...prev.policies,
        [policyType]: value
      }
    }));
  };

  // Professional details change handler
  const handleProfessionalDetailsChange = (field, value) => {
    setProfileData(prev => ({
      ...prev,
      professionalDetails: {
        ...prev.professionalDetails,
        [field]: value
      }
    }));
  };

  // Load photographer data to get name and profile photo
  const loadPhotographerData = async (userId) => {
    try {
      const userDoc = await getDoc(doc(db, 'photographers', userId));
      if (userDoc.exists()) {
        const userData = userDoc.data();
        setPhotographerData(userData);
        setPhotographerName(userData.name || userData.displayName || 'Photographer');
        setProfilePhoto(userData.profileImage || null);
      } else {
        if (auth.currentUser) {
          setPhotographerName(auth.currentUser.displayName || 'Photographer');
        }
      }
    } catch (error) {
      console.error('Error loading photographer data:', error);
      if (auth.currentUser) {
        setPhotographerName(auth.currentUser.displayName || 'Photographer');
      }
    }
  };

  // Handle logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      LocalStorageHelper.clearLoginData();
      navigate('/Login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  // Handle home navigation
  const handleHomeNavigation = () => {
    navigate('/LandingPage');
    closeSidebar();
  };

  // Enhanced Firebase Authentication Check - Load data in background
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const loginData = LocalStorageHelper.getLoginData();
          let userType = loginData.userType || 'user';
          
          const basicProfile = {
            id: user.uid,
            name: user.displayName || loginData.userName || "User",
            email: user.email || loginData.userEmail,
            userType: userType,
            avatar: generateAvatarUrl({}, user),
            isVerified: user.emailVerified || false
          };
          
          setUserProfile(basicProfile);
          setAvatarUrl(basicProfile.avatar);
          setPhotographerName(basicProfile.name);
          
          const basicFormData = {
            name: basicProfile.name,
            email: basicProfile.email,
            phone: '',
            location: '',
            profileImage: '',
            dateOfBirth: '',
            state: '',
            city: '',
            address: '',
            language: '', // CHANGED: No default value
            description: '',
            serviceAreas: [],
            serviceCategories: {},
            hasStudio: false,
            studioName: '',
            studioAddress: '',
            studioPhone: '',
            gstNumber: '',
            policies: {
              cancellationPolicy: '',
              paymentTerms: '',
              travelCostBearer: '',
              deliveryTime: ''
            },
            professionalDetails: {
              workLocation: '',
              proficientPosing: false,
              completedProjects: 0
            }
          };
          
          setProfileData(basicFormData);
          setOriginalProfileData(basicFormData);
          
          console.log('Loading detailed data from Firebase...');
          
          let userDocRef = doc(db, userType === 'vendor' || userType === 'photographer' ? 'photographers' : 'users', user.uid);
          let userDoc = await getDoc(userDocRef);
          
          if (!userDoc.exists()) {
            console.log('User not found in expected collection, trying alternative...');
            userType = userType === 'vendor' || userType === 'photographer' ? 'user' : 'photographer';
            userDocRef = doc(db, userType === 'photographer' ? 'photographers' : 'users', user.uid);
            userDoc = await getDoc(userDocRef);
            
            if (userDoc.exists()) {
              LocalStorageHelper.saveLoginData(
                user.uid,
                user.email,
                user.displayName || "User",
                userType
              );
            }
          }
          
          if (userDoc.exists()) {
            const userData = userDoc.data();
            console.log('Detailed user data loaded from Firestore:', userData);
            
            const avatar = generateAvatarUrl(userData, user);
            
            const detailedProfile = {
              id: user.uid,
              name: userData.name || user.displayName || "User",
              email: userData.email || user.email,
              userType: userType,
              avatar: avatar,
              isVerified: user.emailVerified || userData.emailVerified || false
            };
            
            setUserProfile(detailedProfile);
            setAvatarUrl(avatar);
            setPhotographerName(detailedProfile.name);
            
            const detailedFormData = {
              name: userData.name || user.displayName || '',
              email: userData.email || user.email || '',
              phone: userData.phoneNumber || userData.phone || '',
              location: userData.location || '',
              profileImage: userData.profileImage || '',
              dateOfBirth: userData.dateOfBirth || '',
              state: userData.state || '',
              city: userData.city || '',
              address: userData.address || '',
              language: userData.language || '', // CHANGED: No default to 'English'
              description: userData.description || '',
              serviceAreas: userData.serviceAreas || userData.serviceableAreas || [],
              serviceCategories: userData.serviceCategories || userData.serviceableCategoriesWithPrices || {},
              hasStudio: userData.hasStudio || false,
              studioName: userData.studioName || '',
              studioAddress: userData.studioAddress || '',
              studioPhone: userData.studioPhoneNumber || userData.studioPhone || '',
              gstNumber: userData.gstNumber || '',
              policies: userData.policies || {
                cancellationPolicy: '',
                paymentTerms: '',
                travelCostBearer: '',
                deliveryTime: ''
              },
              professionalDetails: userData.professionalDetails || {
                workLocation: '',
                proficientPosing: false,
                completedProjects: 0
              }
            };
            
            setProfileData(detailedFormData);
            setOriginalProfileData(detailedFormData);
            
            if (userData.profileImage) {
              setAvatarUrl(userData.profileImage);
              setProfilePhoto(userData.profileImage);
            }
            
            LocalStorageHelper.saveLoginData(
              user.uid,
              userData.email || user.email,
              userData.name || user.displayName || "User",
              userType
            );
          }
          
          setDataLoaded(true);
          console.log('Profile data loaded successfully');
          
        } catch (error) {
          console.error('Error fetching user data:', error);
          setDataLoaded(true);
        }
      } else {
        console.log('No user logged in, redirecting to login');
        navigate('/login');
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile && !sidebarVisible) {
        setSidebarVisible(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [sidebarVisible]);

  // Calculate profile completion when profileData changes
  useEffect(() => {
    if (dataLoaded && profileData.name) {
      const completion = calculateProfileCompletion();
      console.log('Profile completion calculated:', completion, '%');
    }
  }, [profileData, dataLoaded, calculateProfileCompletion]);

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  const closeSidebar = () => {
    if (isMobile) {
      setSidebarVisible(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setProfileData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleRevertChanges = () => {
    if (originalProfileData) {
      setProfileData({ ...originalProfileData });
      setAvatarUrl(generateAvatarUrl(originalProfileData, auth.currentUser));
      alert('Changes reverted to last saved state!');
    }
  };

  // UPDATED handleSubmit function with deleteField for ALL fields - FIXED language handling
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!userProfile) {
      alert('User profile not loaded. Please refresh the page.');
      return;
    }
    
    try {
      setSaving(true);
      console.log('Saving profile data:', profileData);
      
      const userType = userProfile.userType || 'user';
      
      // Calculate profile completion before saving - now includes all required fields
      const completion = calculateProfileCompletion();
      
      // Create policies object with deleteField for empty values
      const updatedPolicies = { ...profileData.policies };
      Object.keys(updatedPolicies).forEach(key => {
        if (!updatedPolicies[key] || updatedPolicies[key].toString().trim() === '') {
          updatedPolicies[key] = deleteField();
        }
      });

      // Create professional details object with proper handling
      const updatedProfessionalDetails = { ...profileData.professionalDetails };
      if (!updatedProfessionalDetails.workLocation || updatedProfessionalDetails.workLocation.toString().trim() === '') {
        updatedProfessionalDetails.workLocation = deleteField();
      }

      const updateData = {
        // Required fields (never delete)
        name: profileData.name.trim(),
        email: profileData.email,
        
        // ALL fields use deleteField() if empty - FIXED language field
        phone: (!profileData.phone || profileData.phone.toString().trim() === '') ? deleteField() : profileData.phone.trim(),
        location: (!profileData.location || profileData.location.toString().trim() === '') ? deleteField() : profileData.location.trim(),
        profileImage: (!profileData.profileImage || profileData.profileImage.toString().trim() === '') ? deleteField() : profileData.profileImage.trim(),
        
        // FIXED: Language field - use deleteField for empty values (no special handling for 'English')
        language: (!profileData.language || profileData.language.toString().trim() === '') ? deleteField() : profileData.language,
        dateOfBirth: (!profileData.dateOfBirth || profileData.dateOfBirth.toString().trim() === '') ? deleteField() : profileData.dateOfBirth,
        state: (!profileData.state || profileData.state.toString().trim() === '') ? deleteField() : profileData.state,
        city: (!profileData.city || profileData.city.toString().trim() === '') ? deleteField() : profileData.city,
        address: (!profileData.address || profileData.address.toString().trim() === '') ? deleteField() : profileData.address.trim(),
        
        description: (!profileData.description || profileData.description.toString().trim() === '') ? deleteField() : profileData.description.trim(),
        
        // Service areas and categories (keep as arrays/objects)
        serviceAreas: profileData.serviceAreas,
        serviceableAreas: profileData.serviceAreas,
        serviceCategories: profileData.serviceCategories,
        serviceableCategoriesWithPrices: profileData.serviceCategories,
        
        // Studio information
        hasStudio: profileData.hasStudio,
        studioName: (!profileData.studioName || profileData.studioName.toString().trim() === '') ? deleteField() : profileData.studioName.trim(),
        studioAddress: (!profileData.studioAddress || profileData.studioAddress.toString().trim() === '') ? deleteField() : profileData.studioAddress.trim(),
        studioPhoneNumber: (!profileData.studioPhone || profileData.studioPhone.toString().trim() === '') ? deleteField() : profileData.studioPhone.trim(),
        gstNumber: (!profileData.gstNumber || profileData.gstNumber.toString().trim() === '') ? deleteField() : profileData.gstNumber.trim(),
        
        // Nested objects
        policies: updatedPolicies,
        professionalDetails: updatedProfessionalDetails,
        
        // System fields - UPDATED: Now reflects accurate completion based on all required fields
        profileComplete: completion,
        updatedAt: new Date(),

        // CLEANUP: Remove duplicate phoneNumber field if it exists
        phoneNumber: deleteField()
      };

      console.log('Data to update in Firestore:', updateData);
      
      const userDocRef = doc(db, userType === 'vendor' || userType === 'photographer' ? 'photographers' : 'users', userProfile.id);
      await updateDoc(userDocRef, updateData);
      
      if (profileData.name !== userProfile.name && auth.currentUser) {
        await updateProfile(auth.currentUser, {
          displayName: profileData.name
        });
      }
      
      LocalStorageHelper.saveLoginData(
        userProfile.id,
        profileData.email,
        profileData.name,
        userType
      );
      
      setUserProfile(prev => ({
        ...prev,
        name: profileData.name
      }));
      
      setOriginalProfileData({ ...profileData });
      
      if (profileData.profileImage) {
        setAvatarUrl(profileData.profileImage);
      }
      
      setPhotographerName(profileData.name);
      setProfilePhoto(profileData.profileImage);
      
      // Show appropriate success message based on completion - now includes all required fields
      if (completion === 100) {
        alert('Profile updated successfully! Your profile is now 100% complete and visible to clients.');
      } else {
        alert(`Profile updated successfully! Your profile is ${completion}% complete. Complete remaining fields to be visible to clients.`);
      }
      
    } catch (error) {
      console.error('Error updating profile:', error);
      alert('Failed to update profile. Please check your connection and try again.');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete your account? This action cannot be undone and will permanently remove all your data.')) {
      try {
        console.log('Account deletion requested for user:', userProfile?.id);
        alert('Account deletion feature will be implemented soon. Please contact support for assistance.');
      } catch (error) {
        console.error('Error deleting account:', error);
        alert('Failed to delete account. Please contact support for assistance.');
      }
    }
  };

  const handleUpdateAvatar = () => {
    const newImageUrl = prompt('Enter new profile image URL:');
    if (newImageUrl && newImageUrl.trim()) {
      setProfileData(prev => ({
        ...prev,
        profileImage: newImageUrl.trim()
      }));
      setAvatarUrl(newImageUrl.trim());
    }
  };

  const handleRemoveAvatar = () => {
    if (window.confirm('Are you sure you want to remove your profile picture?')) {
      setProfileData(prev => ({
        ...prev,
        profileImage: ''
      }));
      const fallbackAvatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(profileData.name || 'User')}&background=6366f1&color=fff&size=128&bold=true&font-size=0.6`;
      setAvatarUrl(fallbackAvatar);
    }
  };

  const getProfileCompletion = () => {
    const fields = ['name', 'email', 'phone', 'location', 'state', 'city', 'description'];
    const filledFields = fields.filter(field => profileData[field] && profileData[field].toString().trim() !== '');
    return Math.round((filledFields.length / fields.length) * 100);
  };

  // Modal handlers
  const closeProfileIncompleteModal = () => {
    setShowProfileIncompleteModal(false);
  };

  const handleCompleteProfile = () => {
    setShowProfileIncompleteModal(false);
    // Scroll to first missing field or just scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Show profile completion popup when clicking on profile completion percentage
  const handleProfileCompletionClick = () => {
    if (profileCompletion < 100) {
      setShowProfileIncompleteModal(true);
    }
  };

  return (
    <div className="profile-container">
      <DashboardSidebar
        activeItem="profile"
        visible={sidebarVisible}
        isMobile={isMobile}
        onToggle={toggleSidebar}
        onClose={closeSidebar}
        userName={photographerName}
        profilePhoto={profilePhoto}
        onHome={handleHomeNavigation}
        onLogout={handleLogout}
      />

      {/* Main Content */}
      <div className={`profile-main-content ${
        !sidebarVisible && !isMobile ? 'expanded' : ''
      }`}>
        <h1 className="profile-page-title">Profile Settings</h1>

        {/* Profile Completion Alert */}
        {dataLoaded && profileCompletion < 100 && (
          <div className="profile-completion-alert">
            <div className="profile-completion-alert-content">
              <div className="profile-completion-alert-icon">
                <AlertTriangle size={24} />
              </div>
              <div className="profile-completion-alert-text">
                <h3>Profile Incomplete ({profileCompletion}%)</h3>
                <p>Your profile needs to be 100% complete to be visible to clients in the Browse Photographers section.</p>
              </div>
              <button 
                className="profile-completion-alert-btn"
                onClick={handleCompleteProfile}
              >
                Complete Now
              </button>
            </div>
          </div>
        )}

        {/* Profile Incomplete Modal */}
        {showProfileIncompleteModal && (
          <div className="profile-modal-overlay" onClick={closeProfileIncompleteModal}>
            <div className="profile-modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="profile-modal-header">
                <div className="profile-modal-icon-warning">
                  <AlertTriangle size={32} />
                </div>
                <h2>Complete Your Profile to Get Visibility</h2>
                <button 
                  className="profile-modal-close"
                  onClick={closeProfileIncompleteModal}
                >
                  <X size={20} />
                </button>
              </div>
              
              <div className="profile-modal-body">
                <div className="profile-completion-progress">
                  <div className="profile-progress-bar">
                    <div 
                      className="profile-progress-fill"
                      style={{ width: `${profileCompletion}%` }}
                    ></div>
                  </div>
                  <span className="profile-progress-text">{profileCompletion}% Complete</span>
                </div>
                
                <p className="profile-modal-description">
                  Your profile is not visible to potential clients. Complete these missing fields to start receiving bookings:
                </p>
                
                <div className="profile-missing-fields">
                  {missingFields.map((field, index) => (
                    <div key={index} className="profile-missing-field">
                      <span className="profile-missing-field-icon">{field.icon}</span>
                      <span className="profile-missing-field-label">{field.label}</span>
                    </div>
                  ))}
                </div>
                
                <div className="profile-modal-actions">
                  <button 
                    className="profile-btn-secondary"
                    onClick={closeProfileIncompleteModal}
                  >
                    I'll Complete Later
                  </button>
                  <button 
                    className="profile-btn-primary"
                    onClick={handleCompleteProfile}
                  >
                    Complete Profile Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {!dataLoaded && (
          <div className="profile-loading-indicator">
            <div className="profile-loading-spinner"></div>
            <span>Loading profile data</span>
          </div>
        )}

        <section className="profile-content-section">
          <div className="profile-section-header">
            <UserCircle size={20} style={{ color: '#ff4d4d' }} />
            <h2 className="profile-section-title">Personal Information</h2>
          </div>

          <form className="profile-form" onSubmit={handleSubmit}>
            {/* <div className="profile-header">
              <div className="profile-avatar-container">
                <div className="profile-avatar-large">
                  <img 
                    src={avatarUrl} 
                    alt={userProfile?.name || 'User'} 
                    style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover' }}
                    onError={(e) => {
                      e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(userProfile?.name || 'User')}&background=6366f1&color=fff&size=128&bold=true&font-size=0.6`;
                    }}
                  />
                </div>
              </div>
              <div className="profile-actions">

                <button type="button" className="profile-btn-icon" onClick={handleRemoveAvatar}>
                  <span>Remove</span>
                </button>
              </div>
            </div> */}

            <div className="profile-form-grid">
              <div className="profile-form-group">
                <label>
                  Name *
                  <HelpCircle size={16} className="profile-help-icon" />
                </label>
                <input
                  type="text"
                  name="name"
                  value={profileData.name}
                  onChange={handleChange}
                  placeholder="Enter your full name"
                  required
                />
              </div>

              <div className="profile-form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={profileData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  disabled
                  style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                />
                <small style={{ color: '#666', fontSize: '0.8rem' }}>
                  Email cannot be changed
                </small>
              </div>

              <div className="profile-form-group">
                <label>Phone *</label>
                <input
                  type="tel"
                  name="phone"
                  value={profileData.phone}
                  onChange={handleChange}
                  placeholder="Enter your phone number"
                  required
                />
              </div>

              <div className="profile-form-group">
                <label>Location *</label>
                <input
                  type="text"
                  name="location"
                  value={profileData.location}
                  onChange={handleChange}
                  placeholder="Enter your location"
                  required
                />
              </div>

              <div className="profile-form-group">
                <label>Language *</label>
                <div className="profile-select-wrapper">
                  <select
                    name="language"
                    value={profileData.language}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Language</option>
                    <option value="English">English</option>
                    <option value="Hindi">Hindi</option>
                    <option value="Marathi">Marathi</option>
                    <option value="Gujarati">Gujarati</option>
                    <option value="Tamil">Tamil</option>
                    <option value="Telugu">Telugu</option>
                  </select>
                  <ChevronDown size={16} className="profile-select-arrow" />
                </div>
              </div>

              <div className="profile-form-group">
                <label>
                  Date of Birth *
                  <HelpCircle size={16} className="profile-help-icon" />
                </label>
                <input
                  type="date"
                  name="dateOfBirth"
                  value={profileData.dateOfBirth}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="profile-form-group">
                <label>State *</label>
                <div className="profile-select-wrapper">
                  <select
                    name="state"
                    value={profileData.state}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select State</option>
                    <option value="Maharashtra">Maharashtra</option>
                    <option value="Delhi">Delhi</option>
                    <option value="Karnataka">Karnataka</option>
                    <option value="Tamil Nadu">Tamil Nadu</option>
                    <option value="Gujarat">Gujarat</option>
                    <option value="Rajasthan">Rajasthan</option>
                    <option value="West Bengal">West Bengal</option>
                    <option value="Uttar Pradesh">Uttar Pradesh</option>
                    <option value="Punjab">Punjab</option>
                    <option value="Haryana">Haryana</option>
                  </select>
                  <ChevronDown size={16} className="profile-select-arrow" />
                </div>
              </div>

              <div className="profile-form-group">
                <label>City *</label>
                <div className="profile-select-wrapper">
                  <select
                    name="city"
                    value={profileData.city}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select City</option>
                    <option value="Mumbai">Mumbai</option>
                    <option value="Pune">Pune</option>
                    <option value="Nagpur">Nagpur</option>
                    <option value="Delhi">Delhi</option>
                    <option value="Bangalore">Bangalore</option>
                    <option value="Chennai">Chennai</option>
                    <option value="Kolkata">Kolkata</option>
                    <option value="Hyderabad">Hyderabad</option>
                    <option value="Ahmedabad">Ahmedabad</option>
                    <option value="Jaipur">Jaipur</option>
                  </select>
                  <ChevronDown size={16} className="profile-select-arrow" />
                </div>
              </div>

              <div className="profile-form-group profile-form-group--full">
                <label>Address *</label>
                <textarea
                  name="address"
                  value={profileData.address}
                  onChange={handleChange}
                  placeholder="Enter your complete address"
                  rows="3"
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    fontSize: '0.875rem',
                    resize: 'vertical',
                    fontFamily: 'inherit'
                  }}
                />
              </div>

              <div className="profile-form-group profile-form-group--full">
                <label>
                  Professional Description *
                  <Edit3 size={16} className="profile-help-icon" />
                </label>
                <textarea
                  name="description"
                  value={profileData.description}
                  onChange={handleChange}
                  placeholder="Tell us about your photography style and experience..."
                  rows="4"
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    fontSize: '0.875rem',
                    resize: 'vertical',
                    fontFamily: 'inherit'
                  }}
                />
                <small style={{ color: '#666', fontSize: '0.8rem' }}>
                  Describe your photography style, experience, and what makes you unique
                </small>
              </div>

              <div className="profile-form-group">
                <label style={{ flexDirection: 'row', alignItems: 'center', gap: '0.5rem' }}>
                  <input
                    type="checkbox"
                    name="hasStudio"
                    checked={profileData.hasStudio}
                    onChange={handleChange}
                    style={{ width: 'auto', margin: 0 }}
                  />
                  I have a studio
                </label>
              </div>

              {profileData.hasStudio && (
                <>
                  <div className="profile-form-group">
                    <label>Studio Name</label>
                    <input
                      type="text"
                      name="studioName"
                      value={profileData.studioName}
                      onChange={handleChange}
                      placeholder="Enter your studio name"
                    />
                  </div>

                  <div className="profile-form-group">
                    <label>Studio Phone</label>
                    <input
                      type="tel"
                      name="studioPhone"
                      value={profileData.studioPhone}
                      onChange={handleChange}
                      placeholder="Enter studio phone number"
                    />
                  </div>

                  <div className="profile-form-group profile-form-group--full">
                    <label>Studio Address</label>
                    <textarea
                      name="studioAddress"
                      value={profileData.studioAddress}
                      onChange={handleChange}
                      placeholder="Enter your studio address"
                      rows="3"
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '1px solid #ddd',
                        borderRadius: '8px',
                        fontSize: '0.875rem',
                        resize: 'vertical',
                        fontFamily: 'inherit'
                      }}
                    />
                  </div>

                  <div className="profile-form-group">
                    <label>GST Number</label>
                    <input
                      type="text"
                      name="gstNumber"
                      value={profileData.gstNumber}
                      onChange={handleChange}
                      placeholder="Enter GST number (optional)"
                    />
                  </div>
                </>
              )}

              {/* <div className="profile-form-group profile-form-group--full">
                <label>Profile Image URL *</label>
                <input
                  type="url"
                  name="profileImage"
                  value={profileData.profileImage}
                  onChange={handleChange}
                  placeholder="Enter profile image URL"
                  required
                  onBlur={(e) => {
                    if (e.target.value.trim()) {
                      setAvatarUrl(e.target.value.trim());
                    }
                  }}
                />
                <small style={{ color: '#666', fontSize: '0.8rem' }}>
                  Enter a valid image URL to update your profile picture
                </small>
              </div> */}
            </div>
          </form>
        </section>

        {/* Professional Details Section */}
        <section className="profile-content-section">
          <div className="profile-section-header">
            <Award size={20} style={{ color: '#ff4d4d' }} />
            <h2 className="profile-section-title">Professional Details</h2>
          </div>
          
          <div className="profile-edit-section">
            <h3 className="profile-edit-title">
              <Edit3 size={16} style={{ marginRight: '0.5rem' }} />
              Set Your Professional Information *
            </h3>
            
            <div className="professional-details-container">
              <div className="professional-detail-group">
                <label className="professional-detail-label">
                  <span className="professional-detail-number">1</span>
                  On Location vs Studio *
                </label>
                <div className="professional-detail-options">
                  {[
                    { value: 'on_location', label: 'On Location' },
                    { value: 'studio', label: 'Studio' },
                    { value: 'both', label: 'Both' }
                  ].map((option) => (
                    <div
                      key={option.value}
                      className={`professional-detail-option ${profileData.professionalDetails.workLocation === option.value ? 'selected' : ''}`}
                      onClick={() => handleProfessionalDetailsChange('workLocation', option.value)}
                    >
                      <div className="professional-detail-option-content">
                        <span className="professional-detail-option-label">{option.label}</span>
                        <div className="professional-detail-option-radio">
                          <input
                            type="radio"
                            name="workLocation"
                            value={option.value}
                            checked={profileData.professionalDetails.workLocation === option.value}
                            onChange={() => handleProfessionalDetailsChange('workLocation', option.value)}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="professional-detail-group">
                <label className="professional-detail-label">
                  <span className="professional-detail-number">2</span>
                  Proficient Posing
                </label>
                <div className="professional-detail-options">
                  {[
                    { value: true, label: 'Yes' },
                    { value: false, label: 'No' }
                  ].map((option) => (
                    <div
                      key={option.value.toString()}
                      className={`professional-detail-option ${profileData.professionalDetails.proficientPosing === option.value ? 'selected' : ''}`}
                      onClick={() => handleProfessionalDetailsChange('proficientPosing', option.value)}
                    >
                      <div className="professional-detail-option-content">
                        <span className="professional-detail-option-label">{option.label}</span>
                        <div className="professional-detail-option-radio">
                          <input
                            type="radio"
                            name="proficientPosing"
                            value={option.value.toString()}
                            checked={profileData.professionalDetails.proficientPosing === option.value}
                            onChange={() => handleProfessionalDetailsChange('proficientPosing', option.value)}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="professional-detail-group">
                <label className="professional-detail-label">
                  <span className="professional-detail-number">3</span>
                  Completed Projects
                </label>
                <div className="professional-detail-input-group">
                  <div className="professional-detail-numeric-input">
                    <Hash size={16} className="professional-detail-input-icon" />
                    <input
                      type="number"
                      name="completedProjects"
                      value={profileData.professionalDetails.completedProjects}
                      onChange={(e) => handleProfessionalDetailsChange('completedProjects', parseInt(e.target.value) || 0)}
                      placeholder="Enter number of completed projects"
                      min="0"
                      className="professional-detail-number-input"
                    />
                  </div>
                  <div className="professional-detail-input-hint">
                    <span>Include all photography projects you've completed professionally</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="profile-display-section">
            <h3 className="profile-display-title">
              <Award size={16} style={{ marginRight: '0.5rem' }} />
              Current Professional Details
            </h3>
            <div className="professional-details-summary">
              <div className="professional-detail-summary-grid">
                <div className="professional-detail-summary-item">
                  <div className="professional-detail-summary-label">
                    <span className="professional-detail-summary-icon">📍</span>
                    Work Location
                  </div>
                  <div className="professional-detail-summary-value">
                    {profileData.professionalDetails.workLocation ? (
                      <span className="professional-detail-summary-text">
                        {profileData.professionalDetails.workLocation === 'on_location' && 'On Location'}
                        {profileData.professionalDetails.workLocation === 'studio' && 'Studio'}
                        {profileData.professionalDetails.workLocation === 'both' && 'Both'}
                      </span>
                    ) : (
                      <span className="professional-detail-summary-empty">Not set</span>
                    )}
                  </div>
                </div>

                <div className="professional-detail-summary-item">
                  <div className="professional-detail-summary-label">
                    <span className="professional-detail-summary-icon">🎯</span>
                    Proficient Posing
                  </div>
                  <div className="professional-detail-summary-value">
                    <span className="professional-detail-summary-text">
                      {profileData.professionalDetails.proficientPosing ? 'Yes' : 'No'}
                    </span>
                  </div>
                </div>

                <div className="professional-detail-summary-item">
                  <div className="professional-detail-summary-label">
                    <span className="professional-detail-summary-icon">📊</span>
                    Completed Projects
                  </div>
                  <div className="professional-detail-summary-value">
                    <span className="professional-detail-summary-text">
                      {profileData.professionalDetails.completedProjects} Projects
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Enhanced Service Areas Section with Multiselect */}
        <section className="profile-content-section">
          <div className="profile-section-header">
            <MapPin size={20} style={{ color: '#ff4d4d' }} />
            <h2 className="profile-section-title">Service Areas</h2>
          </div>
          
          <div className="profile-edit-section">
            <h3 className="profile-edit-title">
              <Edit3 size={16} style={{ marginRight: '0.5rem' }} />
              Select Service Areas *
            </h3>
            
            <div className="multiselect-container">
              <Multiselect
                options={allServiceAreas}
                selectedValues={getSelectedServiceAreasObjects()}
                onSelect={onServiceAreasSelect}
                onRemove={onServiceAreasRemove}
                displayValue="name"
                placeholder="Search and select cities..."
                emptyRecordMsg="No cities found"
                groupBy="category"
                showCheckbox={true}
                closeOnSelect={false}
                avoidHighlightFirstOption={true}
                hidePlaceholder={false}
                showArrow={true}
                style={{
                  multiselectContainer: {
                    width: '100%'
                  },
                  searchBox: {
                    border: '2px solid rgba(233, 236, 239, 1)',
                    borderRadius: '16px',
                    padding: '8px 16px',
                    fontSize: '16px',
                    minHeight: '60px',
                    background: 'rgba(248, 249, 250, 1)'
                  },
                  inputField: {
                    margin: '8px',
                    fontSize: '16px',
                    color: '#343434'
                  },
                  chips: {
                    background: '#18181b',
                    borderRadius: '20px',
                    fontSize: '12px',
                    margin: '4px',
                    padding: '6px 12px',
                    color: 'white'
                  },
                  optionContainer: {
                    border: '1px solid rgba(233, 236, 239, 1)',
                    borderRadius: '16px',
                    marginTop: '4px',
                    maxHeight: '300px'
                  },
                  option: {
                    padding: '12px 16px',
                    fontSize: '14px',
                    color: '#343434'
                  },
                  groupHeading: {
                    background: '#fafafa',
                    color: '#18181b',
                    fontSize: '12px',
                    fontWeight: '600',
                    padding: '8px 16px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }
                }}
              />
            </div>
            
            <small style={{ color: '#666', fontSize: '0.8rem', marginTop: '0.5rem', display: 'block' }}>
              Search and select from {allServiceAreas.length} Indian cities. Use checkboxes to select multiple areas.
            </small>
          </div>

          <div className="profile-display-section">
            <h3 className="profile-display-title">
              <MapPin size={16} style={{ marginRight: '0.5rem' }} />
              Selected Service Areas ({profileData.serviceAreas.length})
            </h3>
            <div className="profile-service-areas">
              {profileData.serviceAreas && profileData.serviceAreas.length > 0 ? (
                <div className="enhanced-tags-container">
                  {profileData.serviceAreas.map((area, index) => {
                    const isSpecial = area === "All Mumbai Cities" || area === "All Navi Mumbai Cities";
                    return (
                      <div key={index} className={`enhanced-tag ${isSpecial ? 'special' : ''}`}>
                        {isSpecial ? <Star size={12} /> : <MapPin size={12} />}
                        <span>{area}</span>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="profile-empty-state">
                  <MapPin size={24} style={{ color: '#ccc', marginBottom: '0.5rem' }} />
                  <p>No service areas selected</p>
                  <small>Select service areas above to let clients know where you work</small>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Enhanced Service Categories Section */}
        <section className="profile-content-section">
          <div className="profile-section-header">
            <Camera size={20} style={{ color: '#ff4d4d' }} />
            <h2 className="profile-section-title">Photography Services & Pricing</h2>
          </div>
          
          <div className="profile-edit-section">
            <h3 className="profile-edit-title">
              <Edit3 size={16} style={{ marginRight: '0.5rem' }} />
              Add Photography Service *
            </h3>
            
            <div className="enhanced-service-form">
              <div className="multiselect-container">
                <Multiselect
                  options={allServiceCategories.filter(cat => !profileData.serviceCategories[cat.name])}
                  selectedValues={selectedCategory ? [allServiceCategories.find(cat => cat.name === selectedCategory)] : []}
                  onSelect={(selectedList) => {
                    if (selectedList.length > 0) {
                      setSelectedCategory(selectedList[selectedList.length - 1].name);
                    }
                  }}
                  onRemove={() => {
                    setSelectedCategory('');
                  }}
                  displayValue="name"
                  placeholder="Search and select photography category..."
                  emptyRecordMsg="No categories found"
                  groupBy="category"
                  singleSelect={true}
                  closeOnSelect={true}
                  avoidHighlightFirstOption={true}
                  showArrow={true}
                  style={{
                    multiselectContainer: {
                    width: '100%'
                  },
                  searchBox: {
                    border: '2px solid rgba(233, 236, 239, 1)',
                    borderRadius: '16px',
                    padding: '8px 16px',
                    fontSize: '16px',
                    minHeight: '60px',
                    background: 'rgba(248, 249, 250, 1)'
                  },
                  inputField: {
                    margin: '8px',
                    fontSize: '16px',
                    color: '#343434'
                  },
                  chips: {
                    background: '#18181b',
                    borderRadius: '20px',
                    fontSize: '12px',
                    margin: '4px',
                    padding: '6px 12px',
                    color: 'white'
                  },
                  optionContainer: {
                    border: '1px solid rgba(233, 236, 239, 1)',
                    borderRadius: '16px',
                    marginTop: '4px',
                    maxHeight: '250px'
                  },
                  option: {
                    padding: '12px 16px',
                    fontSize: '14px',
                    color: '#343434'
                  },
                  groupHeading: {
                    background: '#fafafa',
                    color: '#18181b',
                    fontSize: '12px',
                    fontWeight: '600',
                    padding: '8px 16px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }
                }}
              />
            </div>
            
            <div className="enhanced-price-input">
              <span className="enhanced-currency">₹</span>
              <input
                type="number"
                placeholder="Enter starting price"
                value={categoryPrice}
                onChange={(e) => setCategoryPrice(e.target.value)}
                min="0"
                step="100"
              />
            </div>
            
            <button
              type="button"
              className="enhanced-add-btn"
              onClick={addServiceCategory}
              disabled={!selectedCategory || !categoryPrice}
            >
              <Plus size={16} />
              Add Service
            </button>
          </div>
          
          <small style={{ color: '#666', fontSize: '0.8rem', marginTop: '0.5rem', display: 'block' }}>
            Search and select from {allServiceCategories.length} photography categories. Add pricing for each service.
          </small>
        </div>

        <div className="profile-display-section">
          <h3 className="profile-display-title">
            <Star size={16} style={{ marginRight: '0.5rem' }} />
            Current Services & Pricing ({Object.keys(profileData.serviceCategories).length})
          </h3>
          <div className="profile-service-categories">
            {profileData.serviceCategories && Object.keys(profileData.serviceCategories).length > 0 ? (
              <div className="enhanced-services-grid">
                {Object.entries(profileData.serviceCategories)
                  .filter(([category, price]) => category.trim() !== '' && price.toString().trim() !== '')
                  .map(([category, price]) => (
                  <div key={category} className="enhanced-service-card">
                    <div className="enhanced-service-icon">
                      <Camera size={20} />
                    </div>
                    <div className="enhanced-service-details">
                      <h4>{category}</h4>
                      <p className="enhanced-service-price">Starting from ₹{price}</p>
                    </div>
                    <button
                      type="button"
                      className="enhanced-service-remove"
                      onClick={() => removeServiceCategory(category)}
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div className="profile-empty-state">
                <Camera size={24} style={{ color: '#ccc', marginBottom: '0.5rem' }} />
                <p>No photography services added</p>
                <small>Add your services and pricing above to attract clients</small>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Enhanced Policies Section */}
      <section className="profile-content-section">
        <div className="profile-section-header">
          <FileText size={20} style={{ color: '#ff4d4d' }} />
          <h2 className="profile-section-title">Business Policies</h2>
        </div>
        
        <div className="profile-edit-section">
          <h3 className="profile-edit-title">
            <Edit3 size={16} style={{ marginRight: '0.5rem' }} />
            Set Your Business Policies *
          </h3>
          
          <div className="policies-container">
            <div className="policy-group">
              <label className="policy-label">
                <span className="policy-number">1</span>
                Please describe your cancellation policy (if a user initiates cancellation) including whether you provide refunds of booking amounts, and terms for doing so. *
              </label>
              <div className="policy-options">
                {[
                  { value: 'partial_refund', label: 'Partial Refund Offered' },
                  { value: 'no_refund', label: 'No Refund Offered' },
                  { value: 'no_refund_date_adjustment', label: 'No Refund Offered However Date Adjustment Can Be Done' },
                  { value: 'full_refund', label: 'Full Refund Offered' }
                ].map((option) => (
                  <div
                    key={option.value}
                    className={`policy-option ${profileData.policies.cancellationPolicy === option.value ? 'selected' : ''}`}
                    onClick={() => handlePolicyChange('cancellationPolicy', option.value)}
                  >
                    <div className="policy-option-content">
                      <span className="policy-option-label">{option.label}</span>
                      <div className="policy-option-radio">
                        <input
                          type="radio"
                          name="cancellationPolicy"
                          value={option.value}
                          checked={profileData.policies.cancellationPolicy === option.value}
                          onChange={() => handlePolicyChange('cancellationPolicy', option.value)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="policy-group">
              <label className="policy-label">
                <span className="policy-number">2</span>
                What are your payment terms? *
              </label>
              <div className="policy-options">
                {[
                  { value: 'upto_25_advance', label: 'Up to 25% Advance' },
                  { value: 'approx_50_advance', label: 'Approx 50% Advance while booking' },
                  { value: '100_advance', label: '100% Advance while booking' }
                ].map((option) => (
                  <div
                    key={option.value}
                    className={`policy-option ${profileData.policies.paymentTerms === option.value ? 'selected' : ''}`}
                    onClick={() => handlePolicyChange('paymentTerms', option.value)}
                  >
                    <div className="policy-option-content">
                      <span className="policy-option-label">{option.label}</span>
                      <div className="policy-option-radio">
                        <input
                          type="radio"
                          name="paymentTerms"
                          value={option.value}
                          checked={profileData.policies.paymentTerms === option.value}
                          onChange={() => handlePolicyChange('paymentTerms', option.value)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="policy-group">
              <label className="policy-label">
                <span className="policy-number">3</span>
                Who bears cost of travel? *
              </label>
              <div className="policy-options">
                {[
                  { value: 'client', label: 'Client' },
                  { value: 'ourselves', label: 'Ourselves' }
                ].map((option) => (
                  <div
                    key={option.value}
                    className={`policy-option ${profileData.policies.travelCostBearer === option.value ? 'selected' : ''}`}
                    onClick={() => handlePolicyChange('travelCostBearer', option.value)}
                  >
                    <div className="policy-option-content">
                      <span className="policy-option-label">{option.label}</span>
                      <div className="policy-option-radio">
                        <input
                          type="radio"
                          name="travelCostBearer"
                          value={option.value}
                          checked={profileData.policies.travelCostBearer === option.value}
                          onChange={() => handlePolicyChange('travelCostBearer', option.value)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="policy-group">
              <label className="policy-label">
                <span className="policy-number">4</span>
                Delivery estimated time?
              </label>
              <div className="policy-input-group">
                <input
                  type="text"
                  name="deliveryTime"
                  value={profileData.policies.deliveryTime}
                  onChange={(e) => handlePolicyChange('deliveryTime', e.target.value)}
                  placeholder="e.g., 7-14 days, 2-3 weeks, 1 month"
                  className="policy-text-input"
                />
                <div className="policy-input-hint">
                  <span>Be specific about your delivery timeline (e.g., "7-14 days for regular sessions, 4-6 weeks for weddings")</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="profile-display-section">
          <h3 className="profile-display-title">
            <FileText size={16} style={{ marginRight: '0.5rem' }} />
            Current Business Policies
          </h3>
          <div className="policies-summary">
            <div className="policy-summary-grid">
              <div className="policy-summary-item">
                <div className="policy-summary-label">
                  <span className="policy-summary-icon">📋</span>
                  Cancellation Policy
                </div>
                <div className="policy-summary-value">
                  {profileData.policies.cancellationPolicy ? (
                    <span className="policy-summary-text">
                      {profileData.policies.cancellationPolicy === 'partial_refund' && 'Partial Refund Offered'}
                      {profileData.policies.cancellationPolicy === 'no_refund' && 'No Refund Offered'}
                      {profileData.policies.cancellationPolicy === 'no_refund_date_adjustment' && 'No Refund, Date Adjustment Available'}
                      {profileData.policies.cancellationPolicy === 'full_refund' && 'Full Refund Offered'}
                    </span>
                  ) : (
                    <span className="policy-summary-empty">Not set</span>
                  )}
                </div>
              </div>

              <div className="policy-summary-item">
                <div className="policy-summary-label">
                  <span className="policy-summary-icon">💳</span>
                  Payment Terms
                </div>
                <div className="policy-summary-value">
                  {profileData.policies.paymentTerms ? (
                    <span className="policy-summary-text">
                      {profileData.policies.paymentTerms === 'upto_25_advance' && 'Up to 25% Advance'}
                      {profileData.policies.paymentTerms === 'approx_50_advance' && '50% Advance while booking'}
                      {profileData.policies.paymentTerms === '100_advance' && '100% Advance while booking'}
                    </span>
                  ) : (
                    <span className="policy-summary-empty">Not set</span>
                  )}
                </div>
              </div>

              <div className="policy-summary-item">
                <div className="policy-summary-label">
                  <span className="policy-summary-icon">🚗</span>
                  Travel Cost
                </div>
                <div className="policy-summary-value">
                  {profileData.policies.travelCostBearer ? (
                    <span className="policy-summary-text">
                      {profileData.policies.travelCostBearer === 'client' && 'Client bears cost'}
                      {profileData.policies.travelCostBearer === 'ourselves' && 'We bear cost'}
                    </span>
                  ) : (
                    <span className="policy-summary-empty">Not set</span>
                  )}
                </div>
              </div>

              <div className="policy-summary-item">
                <div className="policy-summary-label">
                  <span className="policy-summary-icon">⏰</span>
                  Delivery Time
                </div>
                <div className="policy-summary-value">
                  {profileData.policies.deliveryTime ? (
                    <span className="policy-summary-text">{profileData.policies.deliveryTime}</span>
                  ) : (
                    <span className="policy-summary-empty">Not set</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Studio Information Section */}
      {profileData.hasStudio && (
        <section className="profile-content-section">
          <div className="profile-section-header">
            <Settings size={20} style={{ color: '#ff4d4d' }} />
            <h2 className="profile-section-title">Studio Information</h2>
          </div>
          
          <div className="profile-studio-info">
            <div className="profile-studio-grid">
              <div className="profile-studio-item">
                <strong>Studio Name:</strong>
                <span>{profileData.studioName || 'Not specified'}</span>
              </div>
              <div className="profile-studio-item">
                <strong>Studio Phone:</strong>
                <span>{profileData.studioPhone || 'Not specified'}</span>
              </div>
              <div className="profile-studio-item profile-studio-item--full">
                <strong>Studio Address:</strong>
                <span>{profileData.studioAddress || 'Not specified'}</span>
              </div>
              {profileData.gstNumber && (
                <div className="profile-studio-item">
                  <strong>GST Number:</strong>
                  <span>{profileData.gstNumber}</span>
                </div>
              )}
            </div>
          </div>
        </section>
      )}

      <div className="profile-form-actions">
        <button type="submit" className="profile-btn-primary" disabled={saving} onClick={handleSubmit}>
          {saving ? 'Saving...' : 'Save Changes'}
        </button>
        <button type="button" className="profile-btn-outline" onClick={handleRevertChanges}>
          <RotateCcw size={16} style={{ marginRight: '0.5rem' }} />
          Revert Changes
        </button>
        <button type="button" className="profile-btn-outline" onClick={() => {
          navigate(-1);
        }}>
          Cancel
        </button>
        <button type="button" className="profile-btn-delete" onClick={handleDelete}>
          Delete Account
        </button>
      </div>

      {/* Stats Section */}
      <section className="profile-content-section">
        <div className="profile-section-header">
          <Settings size={20} style={{ color: '#ff4d4d' }} />
          <h2 className="profile-section-title">Account Statistics</h2>
        </div>
        
        <div className="profile-stats-grid">
          <div className="profile-stat-card">
            <div className={`profile-stat-value ${userProfile?.isVerified ? 'verified' : 'pending'}`}>
              {userProfile?.isVerified ? 'Verified' : 'Pending'}
            </div>
            <div className="profile-stat-label">Email Status</div>
          </div>
          
          <div className="profile-stat-card" onClick={handleProfileCompletionClick} style={{ cursor: profileCompletion < 100 ? 'pointer' : 'default' }}>
            <div className={`profile-stat-value ${profileCompletion === 100 ? 'complete' : 'incomplete'}`}>
              {profileCompletion}%
            </div>
            <div className="profile-stat-label">Profile Complete</div>
            {profileCompletion < 100 && (
              <small style={{ color: '#ff4d4d', fontSize: '0.7rem' }}>Click to see missing fields</small>
            )}
          </div>

          <div className="profile-stat-card">
            <div className="profile-stat-value">
              {profileData.serviceAreas ? profileData.serviceAreas.length : 0}
            </div>
            <div className="profile-stat-label">Service Areas</div>
          </div>

          <div className="profile-stat-card">
            <div className="profile-stat-value">
              {profileData.serviceCategories ? Object.keys(profileData.serviceCategories).filter(cat => cat.trim() !== '').length : 0}
            </div>
            <div className="profile-stat-label">Services Offered</div>
          </div>

          <div className="profile-stat-card">
            <div className="profile-stat-value">
              {profileData.hasStudio ? 'Yes' : 'No'}
            </div>
            <div className="profile-stat-label">Has Studio</div>
          </div>

          <div className="profile-stat-card">
            <div className="profile-stat-value">
              {profileData.professionalDetails.completedProjects || 0}
            </div>
            <div className="profile-stat-label">Projects Completed</div>
          </div>
        </div>
      </section>
    </div>
  </div>
);
};

export default PhotographProfile;
